import React from 'react'
import { NumberConvert } from '../../../common/numberConvert'

const CancelTotal = ({ store, data }) => {
  return (
    <div className='bg-stone-600/60 flex flex-col gap-3 rounded-md p-5 duration-150'>

      <div className='text-center bg-[#2E2E2E]/50 p-1 whitespace-nowrap rounded-md'>
        {store} 취소 처리
      </div>

      <div className='flex gap-3 justify-between'>
        <p className='tracking-wider'>{`${NumberConvert(Number(data.data0 + data.data1))} 건`}</p>
        <p className='tracking-wider'>|</p>
        <p className='tracking-wider'>{`${NumberConvert(Number(data.data2 + data.data3))} 개`}</p>
      </div>

    </div>
  )
}

export default CancelTotal